import React from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';

import TextBlock from '../../TextBlock';

import Wrapper from './Wrapper';
import WidgetCode from './WidgetCode';
import WidgetContent from './WidgetContent';
import Description from './Description';

class Widget extends React.PureComponent {
  handleDescriptionChange = (value) => {
    this.props.onChangeBlockField(value, 'description');
  }

  render() {
    return (
      <Wrapper>
        <WidgetCode>
          <TextBlock
            plainText
            block={this.props.block}
            placeholder="Добавьте код виджета"
            onChange={this.props.onChangeBlockField}
          />
        </WidgetCode>

        <Description>
          <TextBlock
            block={this.props.block}
            fieldName="description"
            placeholder="Добавьте описание к виджету"
            onChange={this.handleDescriptionChange}
          />
        </Description>

        <WidgetContent dangerouslySetInnerHTML={{ __html: this.props.block.get('value') }} />
      </Wrapper>
    );
  }
}

Widget.propTypes = {
  block: PropTypes.instanceOf(Map).isRequired,
  onChangeBlockField: PropTypes.func,
};

Widget.defaultProps = {
  onChangeBlockField: () => {},
};

export default Widget;
